import { useState, createRef, useEffect } from 'react'
import { useNavigate, useParams } from "react-router-dom"
import SelectImageBanner from './SelectImageBanner_2.js'
import SelectImageIntro from './SelectImageIntro_2.js'

import AddFieldModal from "../components/modal/AddFieldModal"
import RenderPlainForm from "../components/RenderPlainForm"
import { ColorPicker } from "../components/ui/ColorPicker";


import { updateObjState, expired, setSelectedImage } from "../utils"

import { editForm, getForm } from "../db"

function Edit(){
    const { id } = useParams()

    const [keyImageBanner, setKeyImageBanner] = useState(1)    
    const [keyImageIntro, setKeyImageIntro] = useState(1)   

    const [imageBanner, setImageBanner] = useState({})
    const [imageIntro, setImageIntro] = useState({})

    const inputImageRef = createRef()
    const inputImageIntroRef = createRef()

    const [showAddModal, setShowAddModal] = useState(false)    
    const [showUpdateModal, setShowUpdateModal] = useState(false) 
    const [updateField, setUpdateField] = useState() 
       
    const [inputType, setInputType] = useState("text")
    const [err, setErr] = useState("")

    const [loading, setLoading] = useState(true)
    const [initialized, setInitialized] = useState(false)

    const [formModel, setFormModel] = useState(null)
    
    const history = useNavigate()

    const openAddModal = inputType => {
        setUpdateField()

        setShowAddModal(true)
        setInputType(inputType)
    }

    const openEditModal = (field) => {
        setUpdateField(field)
        setInputType(field.type)
        setShowUpdateModal(true)
        setShowAddModal(true)       
    }

    const moveFieldUp = (field) => {
        let _model = Object.assign({}, formModel)

        let currentPosition = _model.fields.findIndex(match => match.id === field.id)
      
        _model.fields.splice(currentPosition, 1);
        _model.fields.splice(currentPosition - 1, 0, field);

        setFormModel(_model)
    }
    
    const moveFieldDown = (field) => {
        let _model = Object.assign({}, formModel)

        let currentPosition = _model.fields.findIndex(match => match.id === field.id)
      
        _model.fields.splice(currentPosition, 1);
        _model.fields.splice(currentPosition + 1, 0, field);

        setFormModel(_model)
    }


    const setFormHeaderBackgroundColor = color => {
        let _model = Object.assign({}, formModel)
        _model.backgroundColor = color
        setFormModel(_model)
    }

    const setFormHeaderColor = color => {
        let _model = Object.assign({}, formModel)
        _model.color = color
        setFormModel(_model)
    }

    const deleteField = (fieldToDelete) => {
        let _model = Object.assign({}, formModel)
        _model.fields = _model.fields.filter(field => !fieldToDelete.find(match => match === field.id))
        setFormModel(_model)
    }


    const addFieldToFormModel = field => {
        let _model = Object.assign({}, formModel)
        _model.fields.push(field)
        setFormModel(_model)
    }

    const updateFieldToFormModel = updatedField => {
        let _model = Object.assign({}, formModel)

        let oldField = _model.fields.findIndex(field => field.id === updatedField.id)
        _model.fields[oldField] = updatedField

        setFormModel(_model)

        setUpdateField()
    }

    

    const sectionTypes = ["page-section-header"]

    const informationTypes = ["information-banner", "information-banner-text", "information-banner-image", "information-banner-image-text", "information-image-text", "information-image", "information-youtube", "information-youtube-banner"]

    const inputTypes = ["short-text", "long-text", "number", "file"]

    const inputMultipleTypes = ["multioption-singleanswer", "multioption-multianswer"]
    const inputMultipleImageTypes = ["multioption-singleanswer-image", "multioption-multianswer-image"]

    function getMaxPage(){
        return Math.max(...formModel.fields.map(o=>o.page)); 
    }

    function incrementPage() {
        
        var result = formModel.currentPage + 1;

        //validate min and max pages
        if(result <= getMaxPage()) {
            setPage(result);        
        }
    }

    function decrementPage() {
        var result = formModel.currentPage - 1;

        //validate min and max pages
        if(result > 0) {
            setPage(result);
        }    
    }

    function setPage(result) {
        let _model = Object.assign({}, formModel)
        _model.currentPage =result;

        setFormModel(_model)

    }



    
    const updateForm = async () => {
        if(loading) return
        setErr("")

        if(!formModel.title.trim()) return setErr("Title is required")
        if(formModel.title.trim().length < 5 || formModel.title.trim().length > 50) return setErr("Title should be 5 - 50 characters long")

        if(formModel.expiration.trim() && formModel.expiration < 1) return setErr("Validity should be at least an hour")

        if(formModel.fields.length < 2) return setErr("You need to add at least one field")

        formModel.topBanner = imageBanner
        formModel.imageIntro = imageIntro

        setLoading(true)
        try{
            await editForm(formModel)
            setLoading(false)
            history("/forms")
        }catch(e){
            setErr(e.message)
            setLoading(false)
        }
    }

    useEffect(() => {
        if(!localStorage.getItem('gfc-user')) return
        const fetchData = async () => {
            try{
                let frm = await getForm({ id })
                if(frm) {
                    frm.currentPage = 1
                    setFormModel(frm)
                }
                setLoading(false)
            }catch(e){
                setLoading(false)
                setErr(e.message)
            }
        }
        fetchData()
    }, [id])

    useEffect(() => {
        
        if(!initialized && formModel?.topBanner?.src) {
            setSelectedImage(formModel.topBanner.src)
            setInitialized(true)
        }

        if(!initialized && formModel?.imageIntro?.src) {
            setSelectedImage(formModel.imageIntro.src)
            setInitialized(true)
        }

    }, [formModel, initialized, setInitialized])

    const manageImageBanner = (selectedImage) => {
        if(selectedImage.src === imageBanner.src){
            setImageBanner({})
            setKeyImageBanner(keyImageBanner + 1)
        } else {
            setImageBanner(selectedImage)
        }
    }

    const manageImageIntro = (selectedImage) => {
        if(selectedImage.src === imageIntro.src){
            setImageIntro({})
            setKeyImageIntro(keyImageIntro + 1)
        } else {
            setImageIntro(selectedImage)
        }
    }


    return (
        loading ? <p className="text-center mt-1"><span className="spinner"></span></p>
        : err ? <h3 className="msg mt-1">{err}</h3>
        : formModel ? expired() ? <h3 className="msg mt-1">This form has been expired</h3>
        : <div className="create-form">
            <h1 className="heading">Editar um formulário</h1>
            
            <div className="form">

                <div className="input">
                    <label>Banner (opcional)</label>

                    <SelectImageBanner onImageSelected={manageImageBanner} 
                                 keyName={keyImageBanner} 
                                 ref={inputImageRef} />
                </div>

                <div className="input">
                    <label>Imagem de Introdução (opcional)</label>
                    <SelectImageIntro onImageSelected={manageImageIntro}
                                      keyName={keyImageIntro}
                                      ref={inputImageIntroRef}  />
                </div>

                <div className="input">
                    <ColorPicker label="Tema - Imagem de fundo: " initialColor={formModel.backgroundColor ? formModel.backgroundColor : "#0b1a98"} onColorChange={setFormHeaderBackgroundColor} />
                </div>

                <div className="input">
                    <ColorPicker label="Tema - Cor de Texto: " initialColor={formModel.color ? formModel.color : "#000000"} onColorChange={setFormHeaderColor} />
                </div>

                <div className="input">
                    <label>Titulo</label>
                    <input type="text" placeholder="O titulo aparece no topo de todas as páginas e é usado para identificar o formulário." value={formModel.title} onChange={e => updateObjState(setFormModel, formModel ,"title", e.target.value)} />
                </div>

                {formModel.fields.length > 0 && <RenderPlainForm model={formModel} openEditModal={openEditModal} deleteField={deleteField} moveFieldUp={moveFieldUp} moveFieldDown={moveFieldDown} />}

                <div className="pages">
                    <button className="btn" onClick={decrementPage}>«</button>
                    <span>                Page: {formModel.currentPage} of {getMaxPage()}                </span>
                    <button className="btn" onClick={incrementPage}>»</button>
                    
                </div>

                <div className="input">
                    <label>Mensagem final</label>
                    <input type="text" placeholder="Representa a mensagem final que é mostrada ao utilizador quando completa um formulário." value={formModel.endMessage} onChange={e => updateObjState(setFormModel, formModel ,"endMessage", e.target.value)} />
                </div>

                <div className="input">
                    <label>Validade (opcional)</label>
                    <input type="number" placeholder="Permite limitar o numero de horas em que o formulário pode ser preenchido." value={formModel.expiration}  onKeyDown={e => {if(e.key==='.' || e.key==='-'){e.preventDefault()}}} onChange={e => updateObjState(setFormModel, formModel ,"expiration", e.target.value)} />
                </div>

                
            </div>

            <p className="mb-2 text-right">
                { err && <p className="err text-right mb-1">{err}</p> }
                <button className="btn" onClick={updateForm}>{ loading ? <span className="spinner white"></span> : <span>Submeter</span>}</button>
            </p>
            

            
            <div className="add-field-container grey-container">
                <h3>Campos</h3>
            </div>


            <div className="add-field-container grey-container">
                <p>Adicionar campos de secções</p>
                { sectionTypes.map((inputType, index) => <button className="btn" key={index} onClick={() => openAddModal(inputType)}>{inputType.replaceAll("-", " ")}</button>)}
            </div>

            <div className="add-field-container grey-container">
                <p>Adicionar campos informativos</p>
                { informationTypes.map((inputType, index) => <button className="btn" key={index} onClick={() => openAddModal(inputType)}>{inputType.replaceAll("-", " ")}</button>)}
            </div>

            <div className="add-field-container grey-container">
                <p>Adicionar campos normais</p>
                { inputTypes.map((inputType, index) => <button className="btn" key={index} onClick={() => openAddModal(inputType)}>{inputType.replaceAll("-", " ")}</button>)}
            </div>
            <div className="add-field-container grey-container">
                <p>Adicionar campos de escolha multipla</p>
                { inputMultipleTypes.map((inputType, index) => <button className="btn" key={index} onClick={() => openAddModal(inputType)}>{inputType.replaceAll("-", " ")}</button>)}
            </div>
            <div className="add-field-container grey-container">
                <p>Adicionar campos de escolha multipla com imagens</p>
                { inputMultipleImageTypes.map((inputType, index) => <button className="btn" key={index} onClick={() => openAddModal(inputType)}>{inputType.replaceAll("-", " ")}</button>)}
            </div>
            
            { (showAddModal || showUpdateModal) && <AddFieldModal inputType={inputType}  
                                            close={() => {
                                                setShowAddModal(false)  
                                                setShowUpdateModal(false)
                                            } } 
                                            add={addFieldToFormModel} 
                                            getMaxPage={() =>  {return getMaxPage()}} 
                                            fields={formModel.fields} 
                                            update={updateFieldToFormModel} 
                                            fieldToUpdate={updateField}/> }


          </div>
        : <h3 className="msg mt-1">Form not found</h3> 

        
    )
}

export default Edit